import React from "react";
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { Card, Col, Container, Input, Label, Row , Button, Spinner} from 'reactstrap';
import AuthSlider from './authCarousel';
import emailValidator from 'email-validator';

import { useDispatch, useSelector } from "react-redux";
import * as loginActions from "../actions/LoginActions";
import * as commonActions from "../actions/CommonActions";

const  LoginScreen = () => {
    const { register, clearErrors, reset, trigger, formState: { errors } } = useForm({mode: 'all'});

    const dispatch = useDispatch();

    const loading = useSelector((state) => state.login.loading);
    const [loadingLocal, setLoadingLocal] = React.useState(false);

    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [otp, setOtp] = React.useState("");
    const [showPassword, setShowPassword] = React.useState(false);
    const [currentStep, setCurrentStep] = React.useState(1);

    const handleSendOTP = async () => {
        const valid = await trigger();
        if(valid) {
            setLoadingLocal(true);
                
            var data = await loginActions.sendOTP(email, password);
            if(data.success) {
                if(data.errorCode === "1") {
                    dispatch(loginActions.loadLogin(email, password, "AAAAAA"));
                }
                else {
                    setCurrentStep(2);
                }
            }
            else {
                dispatch(commonActions.setErrorMessage(data.error));
            }

            setLoadingLocal(false);    
        }
    }

    const handleLoadLogin = async () => {
        const valid = await trigger();
        if(valid) {
            dispatch(loginActions.loadLogin(email, password, otp));
        }
    }

    return(
        <React.Fragment>
            <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="bg-overlay"></div>
                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className="overflow-hidden">
                                    <Row className="g-0">
                                        <AuthSlider />

                                        <Col lg={6}>
                                            <div className="p-lg-5 p-4">
                                                <div>
                                                    <h5 className="text-primary">Welcome Back !</h5>
                                                    <p className="text-muted">Sign in to continue to Ticketing System.</p>
                                                </div>
                                                {currentStep === 1 &&
                                                <div className="mt-4">
                                                    <div className="mb-3">
                                                        <Label className="form-label">Email</Label>
                                                        <input type="text" placeholder="Enter Email" className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                                            title={errors.email?.message}
                                                            value={email || ""}
                                                            {...register("email", { required: "Email is required", validate: (value) => emailValidator.validate(value) || 'Invalid email format' })}
                                                            onChange={e => setEmail(e.target.value)}
                                                        />
                                                    </div>

                                                    <div className="mb-1">
                                                        <Label className="form-label" htmlFor="password-input">Password</Label>
                                                        <div className="position-relative auth-pass-inputgroup">
                                                            <input type={showPassword ? "text" : "password"} placeholder="Enter Password" className={`form-control pe-5 password-input ${errors.password ? "is-invalid" : ""}`}
                                                                title={errors.password?.message}
                                                                value={password || ""}
                                                                {...register("password", { required: "Password is required" })}
                                                                onChange={e => setPassword(e.target.value)}
                                                            />
                                                            <button type="button" className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" style={{boxShadow:"none"}}
                                                                onClick={() => setShowPassword(!showPassword)}
                                                            >
                                                                <i className="ri-eye-fill align-middle"></i>
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className="float-end mb-3">
                                                        <Link to="/forgot-password" className="text-muted">Forgot password?</Link>
                                                    </div>

                                                    <div className="mt-4">
                                                        <Button color="primary" className="w-100" type="button" disabled={loading || loadingLocal} onClick={handleSendOTP}>
                                                            {(loading || loadingLocal) ? <Spinner size="sm" className='me-2'> Verifying... </Spinner> : null}
                                                            Sign In
                                                        </Button>
                                                    </div>
                                                </div>
                                                }
                                                {currentStep === 2 &&
                                                <div className="mt-4">
                                                    <div className="mb-3">
                                                        <Label className="form-label">OTP Code</Label>
                                                        <input type="text" placeholder="Enter OTP" className={`form-control ${errors.otp ? "is-invalid" : ""}`}
                                                            title={errors.otp?.message}
                                                            value={otp || ""}
                                                            {...register("otp", { 
                                                                validate: (value) => {
                                                                    if (currentStep === 2 && !value) {
                                                                        return "OTP is required";
                                                                    }

                                                                    return true;
                                                                }
                                                            })}
                                                            onChange={e => setOtp(e.target.value)}
                                                        />
                                                    </div>

                                                    <div className="float-end mb-3">
                                                        <Link to="/forgot-password" className="text-muted">Forgot password?</Link>
                                                    </div>

                                                    <div className="mt-4">
                                                        <Button color="primary" className="w-100" type="button" disabled={loading || loadingLocal} onClick={handleLoadLogin}>
                                                            {(loading || loadingLocal) ? <Spinner size="sm" className='me-2'> Verifying... </Spinner> : null}
                                                            Verify OTP
                                                        </Button>
                                                    </div>
                                                </div>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <footer className="footer">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center">
                                    <p className="mb-0">&copy; {new Date().getFullYear()} Ticketing System. Crafted with <i className="mdi mdi-heart text-danger"></i> by TUV</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </footer>

            </div>
        </React.Fragment>
    );
}
  
export default LoginScreen;